import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import isEligibleForSelfServeInStore from "../../utils/selfServeInStoreEligibility";

// This field is a computed property on the merchant model that serves as a
// boolean in SF for sales-ops to know that a merchant's stores are added
// through the self-serve process
export class SelfServeInStoreField extends Field<boolean> {
  constructor(model: Merchant, opts: Partial<MerchantField<boolean>> = {}) {
    super(model, {
      dataType: "boolean",
      testValue: true,
      propertyName: "selfServeInStore",
      uiFieldType: undefined,
      required: false,
      shown: false,
      ...opts,
    });
  }

  isMerchantEligibleForSelfServe = (): boolean => {
    const salesChannel = this._model.storeDetails.salesChannel.value;
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const totalAnnualSales = this._model.storeDetails.totalAnnualSales.value;
    const multiTerminal = this._model.storeDetails.multiTerminal.value;

    return isEligibleForSelfServeInStore({
      multiTerminal,
      registeredCountry,
      salesChannel,
      totalAnnualSales,
    });
  };

  get applicable(): boolean {
    return this.isMerchantEligibleForSelfServe();
  }

  get value(): boolean {
    return this.isMerchantEligibleForSelfServe();
  }
}
